import React, { useCallback, useEffect, useState } from 'react';
import '../../assets/css/CurriculumVitae/style.css';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { createCurriculumVitae, getCurriculumVitaeByUserId } from '../../api/curriculumVitaeApi';
import Loading from '../../components/common/Loading';
import { toast } from 'react-toastify';
import { COMPLETE_CURRICULUM_VITAE, getErrorUpdateToastPropsBy } from '../../service/toastService';

function CurriculumVitaeStart() {
  const history = useHistory();
  const currentLoggedUserId = useSelector((state) => state.users.selectedUser.myportalUserId);
  const [loading, setLoading] = useState(true);
  const [cvExists, setCvExists] = useState(false);

  const navigateToWizard = useCallback(
    (cvData) => {
      history.push({
        pathname: `/curriculumVitae/wizard`,
        state: { cvData },
      });
    },
    [history],
  );

  const initializeCurriculumVitae = useCallback(async () => {
    try {
      const response = await getCurriculumVitaeByUserId(currentLoggedUserId);
      if (response.data) {
        navigateToWizard(response.data);
        setCvExists(true);
      } else {
        setCvExists(false);
      }
    } catch {
      toast.error('Something went wrong! Please try again.', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE));
    } finally {
      setLoading(false);
    }
  }, [currentLoggedUserId, navigateToWizard]);

  const handleCreateCurriculumVitae = async () => {
    try {
      await createCurriculumVitae({ userId: currentLoggedUserId });
      initializeCurriculumVitae().then(() => {});
    } catch {
      toast.error('Error creating CV', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE));
    }
  };

  useEffect(() => {
    initializeCurriculumVitae().then(() => {});
  }, [currentLoggedUserId, initializeCurriculumVitae]);

  if (loading) {
    return <Loading message="Hang on, we’re loading your curriculum vitae." />;
  }

  if (!cvExists) {
    return (
      <div className="container-fluid d-flex justify-content-center align-items-center">
        <div className="text-center t4t-card p-5 rounded shadow-lg" style={{ maxWidth: '80%' }}>
          <h1 className="mb-4">Curriculum Vitae</h1>
          <p className="text-secondary" style={{ lineHeight: '1.6', fontSize: '1.1rem' }}>
            This wizard will guide you to input and manage your CV information. An up-to-date CV helps recruiters easily access your profile. You can pause at any time
            and continue later from where you left off.
          </p>
          <p className="text-secondary" style={{ lineHeight: '1.6', fontSize: '1.1rem' }}>
            Click ’Start building your CV’ to begin. After completing all sections, you can make edits through the CV Builder menu.
          </p>
          <p className="font-weight-bold" style={{ fontSize: '1.2rem' }}>
            Good luck!
          </p>
          <button className="btn btn-primary d-flex align-items-center justify-content-center mx-auto mt-3" onClick={handleCreateCurriculumVitae}>
            <i className="pe-7s-plus mr-2"></i>
            <span>Start building CV</span>
          </button>
        </div>
      </div>
    );
  }

  return null;
}

export default CurriculumVitaeStart;
